import React, { useContext, useEffect, useState } from 'react';
import "./Fundallotment.css";
import Application from '../../../StateContext/Application';

const SchemeCreation = () => {
    let operation = useContext(Application);
    const { SchemeCreation } = operation;

    const [FetchedData, setFetchData] = useState([]);
    const [editIndex, setEditIndex] = useState(null);

    const [data, setData] = useState({
        SchemeName: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const HandleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!data.SchemeName || data.SchemeName.trim() === "") {
                return alert("Please Enter Valid Scheme Name !");
            }
            console.log("Data", data);
            let res = await SchemeCreation("CreateScheme", data);
            console.log("baclkend message : ", res);
            alert(res);
            FetchDataintially();
            setData({
                SchemeName: ""
            });
        }
        catch (err) {
            console.log(err);
        }
    }



    const FetchDataintially = async () => {
        try {
            let res = await SchemeCreation("", "null");
            setFetchData(res);
            console.log("Reocreder dta ; ", res);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        FetchDataintially();
    }, []);

    const EditFundAllotment = (id) => {
        let editinfo = FetchedData.filter((item) => item.SchemeID === id);
        let info = editinfo[0];
        console.log(info);
        setEditIndex(id);
        setData({
            SchemeName: info.SchemeName
        })
    };


    const SubmitEdittedData = async (e) => {
        e.preventDefault();
        try {
            let obj = {
                SchemeName: data.SchemeName,
                SchemeID: editIndex
            }
            let res = await SchemeCreation("EditScheme", obj);
            alert(res);

            setEditIndex("");
            setData({
                SchemeName: ""
            });
            FetchDataintially();
        }
        catch (err) {
            console.log(err);
        }
    }

    const DeleteFundAllotment = async (id) => {
        let final = window.confirm("Are you sure ??");

        if (final) {
            try {
                let res = await SchemeCreation("DeleteScheme", id);
                alert(res);
                FetchDataintially();
            }
            catch (err) {
                console.log(err);
            }
        }
        else {
            alert("Cancel Deletion !!");
        }
    }




    return (
        <>


            <div className="col-12">
                <h3 className='text-center fw-bold bg-light'>Scheme Creation</h3>
                <div className="col-12 m-auto my-5 fundAllomentContainer">
                    <div className="m-auto budgetElement">
                        <div className="col-10 m-auto">
                            <form action="" >

                                <div className="col-12 elements">
                                    <div className="row">
                                        <div className="col-4 my-auto ">
                                            <label className='my-auto' >Scheme Name </label>
                                        </div>
                                        <div className="col-8">
                                            <input type="text" placeholder='Enter Scheme Name' value={data.SchemeName} name='SchemeName' onChange={(handleChange)} />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 text-center my-4 mt-5">
                                    {
                                        !editIndex &&
                                        <button className='btn btn-success px-4' onClick={HandleSubmit}>Submit</button>
                                    }
                                    {
                                        editIndex &&
                                        <button className='btn btn-success px-4' onClick={SubmitEdittedData}>Update</button>
                                    }
                                    <button className='btn btn-danger px-4 mx-3' onClick={(e) => { e.preventDefault(); setEditIndex(""); setData({ SchemeName: "" }) }}>Cancel</button>
                                </div>
                            </form>

                        </div>

                    </div>


                    <div className="col-10 m-auto">
                        <div className="tableContainer my-5">
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ width: "15%" }}>Sr.No</th>
                                        <th style={{ width: "15%" }}>Scheme ID </th>
                                        <th style={{ width: "30%" }}>Scheme Name</th>
                                        <th style={{ width: "20%" }}>Date</th>
                                        <th style={{ width: "10%" }}></th>
                                        <th style={{ width: "10%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        FetchedData.length > 0 &&
                                        FetchedData.map((val, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{val.SchemeID}</td>
                                                    <td>{val.SchemeName}</td>
                                                    <td>{new Date(val.CreatedAt).toLocaleString()}</td>
                                                    <td><button className='btn btn-success px-4' onClick={() => EditFundAllotment(val.SchemeID)}>Edit</button></td>
                                                    <td><button className='btn btn-danger px-4' onClick={() => DeleteFundAllotment(val.SchemeID)}>Delete</button></td>
                                                </tr>

                                            )
                                        })
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>


                </div >
            </div >





        </>
    )
}

export default SchemeCreation;